export default __webpack_public_path__ + "static/media/shape-tulip.90b78a69.PNG";